import t from "dayjs";

var r = function r(t) {
  return new Date(t).getTime();
},
    n = function n(t, _n, a, o, e) {
  var M,
      Y = r(t),
      f = r(_n),
      i = r(o),
      u = r(e),
      d = t,
      s = _n;
  return Y < i ? (d = o, s = new Date(i + a).toISOString(), M = "start") : f > u && (s = e, d = new Date(u - a).toISOString(), M = "end"), {
    newStartClamped: d,
    newEndClamped: s,
    clamped: M
  };
},
    a = function a(t, n) {
  return r(n) - r(t);
},
    o = function o(t, r) {
  return a(t, r) / 1e3 / 60 / 60 / 24;
},
    e = function e(t, r) {
  return o(t, r) >= 1;
},
    M = function M(n, a) {
  var o = t(n),
      e = o.startOf(a),
      M = o.endOf(a);
  return (r(n) - e.valueOf() > M.valueOf() - r(n) ? M : e).toISOString();
},
    Y = function Y(r, n) {
  var a = e(r, n) ? "MMM D YYYY" : "MMM D YYYY HH[h]";
  return {
    humanizedStart: t(r).format(a),
    humanizedEnd: t(n).format(a)
  };
},
    f = function f(t, r, n) {
  for (var a, o = function o(t) {
    var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
        n = t.add(6, "day");
    return "".concat(t.format("MMM"), " ").concat(t.format("D"), "-").concat(n.format("D"), " ").concat(r ? t.format("YYYY") : "");
  }, e = {
    year: {
      isFirst: function isFirst() {
        return !1;
      },
      formats: [[0, "YYYY"]]
    },
    month: {
      isFirst: function isFirst(t) {
        return 0 === t.month();
      },
      formats: [[200, "MMMM YYYY"], [100, "MMMM", "MMM YYYY"], [0, "MMM", "MMM YY"]]
    },
    week: {
      isFirst: function isFirst(t) {
        return 1 === t.date();
      },
      formats: [[0, function (t) {
        return o(t);
      }, function (t) {
        return o(t, !0);
      }]]
    },
    day: {
      isFirst: function isFirst(t) {
        return 1 === t.date();
      },
      formats: [[999, "ddd D MMMM YYYY"], [200, "ddd D MMMM"], [70, "ddd D", "MMM 1"], [0, "D", "MMM"]]
    },
    hour: {
      isFirst: function isFirst(t) {
        return 0 === t.hour();
      },
      formats: [[999, "ddd D MMMM YYYY H[H]"], [0, "H[H]", "ddd D"]]
    }
  }[r], M = 0; M < e.formats.length; M += 1) {
    if (n > e.formats[M][0]) {
      a = e.formats[M];
      break;
    }
  }

  var Y = e.isFirst(t) && a[2] ? a[2] : a[1];
  return "function" == typeof Y ? Y(t) : t.format(Y);
},
    i = function i(n, a, o, e, M, Y) {
  for (var i = Math.max(r(a), r(e)), u = Math.min(r(o), r(M)), d = t(i).startOf(Y), s = t(u).endOf(Y), c = [], m = r(o) > r(M) ? 0 : 1, D = s.diff(d, Y) + m, h = d, v = n(h), S = 0; S <= D; S += 1) {
    var O = h.add(1, Y),
        l = n(O),
        g = l - v,
        w = {
      id: h.format({
        year: "YYYY",
        month: "YYYY-MM",
        week: "YYYY-MM-DD",
        day: "YYYY-MM-DD",
        hour: "YYYY-MM-DD-HH"
      }[Y]),
      x: v,
      width: g,
      label: f(h, Y, g),
      hoverLabel: "".concat(f(h, Y, 1 / 0), " - Zoom to ").concat(Y),
      start: h.toISOString(),
      end: O.subtract(1, "hour").toISOString()
    };
    c.push(w), h = O, v = l;
  }

  return c;
};

export { Y as a, o as b, i as c, n as d, a as e, r as g, e as i, M as s };